import { DelegationCollectionName } from '@/entities/delegating-request/types';
import { ApiAccountResponse } from '@/shared/api';
import { BaseDto, DtoId } from '@/shared/lib/sj-orm/models/base.dto';
import { DocumentType } from '@/shared/lib/sj-orm/models/document/document-base.dto';
import { PrivateDocumentDto } from '@/shared/lib/sj-orm/models/document/private.document.dto';
import { DeepPartial } from '@/shared/types/utility-types';

import { AssetDto, PersonalIdentifierDocumentDto } from '.';

export interface DelegatingRequestDto extends BaseDto {
  status: DelegatingRequestStatus;
  relatedEntity?: {
    collectionName: DelegationCollectionName;
    dtoId: DtoId;
  };
  ownerPublicKey?: string;
  from: DeepPartial<ApiAccountResponse>;
  items: Array<DelegatingRequestItemDto>;
}

export type DelegatingRequestItemDto =
  | {
      documentType: DocumentType.PERSONAL_IDENTIFIERS;
      documentDtoIdForReplacing?: DtoId;
      value: PersonalIdentifierDocumentDto;
    }
  | {
      documentType: DocumentType.PRIVATE_DOCUMENTS;
      documentDtoIdForReplacing?: DtoId;
      value: PrivateDocumentDto;
    }
  | {
      documentType: DocumentType.ASSET_INFORMATION;
      documentDtoIdForReplacing?: DtoId;
      value: AssetDto;
    };

export enum DelegatingRequestStatus {
  OPENED_TO_EDIT = 'OPENED_TO_EDIT',
  WAITING_FOR_APPROVE = 'WAITING_FOR_APPROVE',
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
}
